import { useTranslation } from 'next-i18next'

import requireImages from '@/utils/require-images'

import { Description, LargeImageCard, Text } from './elements'

const images = requireImages(['application'], {
  requireFn: (path: string) => require(`./images/${path}`),
  extensions: ['png']
})

const AutomateRenting = ({ breakpoint }: { breakpoint: string }) => {
  const { t } = useTranslation('renters')
  return (
    <LargeImageCard
      long
      breakpoint={breakpoint}
      padding="115px"
      image={images.application[0]}
    >
      <Text>{t('renters:Automate your renting')}</Text>
      <Description large breakpoint={breakpoint} maxWidth="260px">
        {t(
          'renters:Complete your Renter Profile once and apply to multiple listings with just a few clicks.'
        )}
      </Description>
    </LargeImageCard>
  )
}

export default AutomateRenting
